import { user as actionsType } from "../actionsType";
import { client } from "../../utils/network";
import { paths } from "./paths";
import axios from "axios";
import { DOMAIN_API_HOST } from "../../configs/main.js";

export const setUserData = (user) => ({
  type: actionsType.SET_USER_DATA,
  payload: user,
});
export const setUserInfo = (payload) => ({
  type: actionsType.USER_SET_INFO,
  payload,
});

export const setUserRequisites = (payload) => ({
  type: actionsType.USER_SET_REQUISITES,
  payload,
});

export const setAgencyRequisites = (payload) => ({
  type: actionsType.AGENCY_SET_REQUISITES,
  payload,
});

export const updateUserInfo = (payload) => async (dispatch) => {
  await client
    .put(paths.user, {
      ...payload,
    })
    .then((res) => {
      dispatch(setUserInfo(res.data));
    })
    .catch((err) => console.log("err - ", err));
};

export const getUserInfo = () => async (dispatch) => {
  const token = localStorage.getItem("token");
  if (!token) {
    return;
  }
  await client
    .get(paths.user)
    .then((res) => {
      dispatch(setUserInfo(res.data));
    })
    .catch((err) => console.log("getUserInfo err - ", err));
};

export const updateUserRequisites = (payload) => async (dispatch) => {
  await client
    .put(paths.userRequisites, {
      ...payload,
    })
    .then((res) => {
      dispatch(setUserRequisites(res.data));
    })
    .catch((err) => console.log("err - ", err));
};

export const getUserRequisites = () => async (dispatch) => {
  const token = localStorage.getItem("token");
  if (!token) {
    return;
  }

  await axios
    .get(`${DOMAIN_API_HOST}${paths.userRequisites}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      console.log("getUserRequisites res - ", res);
      dispatch(setUserRequisites(res.data));
    })
    .catch((err) => console.log("getUserRequisites err - ", err));
};

export const getAgencyRequisites = () => async (dispatch) => {
  const token = localStorage.getItem("agency_token");
  if (!token) {
    return;
  }
  await axios
    .get(`${DOMAIN_API_HOST}${paths.userRequisites}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      console.log("getAgencyRequisites res - ", res);
      dispatch(setAgencyRequisites(res.data));
    })
    .catch((err) => console.log("getAgencyRequisites err - ", err));
};
